module.exports = __webpack_public_path__ + "img/title4.713d40cc.png";